// @flow
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import markets from '../../data/markets'

const MarketLink = styled(Link)`
  display: block;
  margin-bottom: 3px;
`

const MarketList = () => (
  <div className="row">
    <div className="col-sm-4 col-xs-6" style={{ marginBottom: '1rem' }}>
      {markets.slice(0, 15).map((market) => (
        <MarketLink key={market.city} to={`/properties?q=${market.city}`}>
          {`${market.city} Real Estate`}
        </MarketLink>
      ))}
    </div>
    <div className="col-sm-4 col-xs-6" style={{ marginBottom: '1rem' }}>
      {markets.slice(15, 30).map((market) => (
        <MarketLink key={market.city} to={`/properties?q=${market.city}`}>
          {`${market.city} Real Estate`}
        </MarketLink>
      ))}
    </div>
    <div className="col-sm-4 col-xs-6" style={{ marginBottom: '1rem' }}>
      {markets.slice(30, 45).map((market) => (
        <MarketLink key={market.city} to={`/properties?q=${market.city}`}>
          {`${market.city} Real Estate`}
        </MarketLink>
      ))}
    </div>
  </div>
)

export default MarketList



// WEBPACK FOOTER //
// ./src/components/MarketList/index.js